import React from 'react';

import Photo from './CreatePost/Photo';
import Video from './CreatePost/Video';
import Voice from './CreatePost/Voice';
import Modal from './Modal';
import Text from './CreatePost/Text';

const CreatePost = ({ isOpen, isClose, postType }) => {
  console.log(postType);
  
  return (
    <Modal isOpen={isOpen} isClose={isClose} title="Create a post">
      {postType === 'text' && (<Text close={isClose} />)}
      {postType === 'voice' && (<Voice close={isClose} />)}
      {postType === 'photo' && (<Photo close={isClose} />)}
      {postType === 'video' && (<Video close={isClose} />)}
    </Modal>  
  )
}

export default CreatePost;